import { forwardRef } from "react";
import { useId } from "react";
function SvgRawFormativeLogoIcon({ title, titleId, ...props }, ref) {
  const id = useId();
  const toAppend = "_" + id;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#a)">
        <path
          d="M16.395.833a12.29 12.29 0 0 0-4.75-.834C10.08.05 8.54.403 7.1 1.035c-.708.328-1.415.707-2.047 1.162.202.101.38.228.556.354.48.379.834.834 1.036 1.364.43-.278.884-.53 1.364-.758 1.162-.505 2.4-.783 3.663-.834a9.48 9.48 0 0 1 2.678.304c.278.075.556.151.834.252.227.076.43.177.657.253l1.591-1.82c-.354-.176-.707-.353-1.086-.48h.05Zm.91 19.25a9.653 9.653 0 0 1-4.169 1.516 9.9 9.9 0 0 1-4.395-.48 9.786 9.786 0 0 1-2.704-1.49h-.025a1.186 1.186 0 0 0-1.617.202c-.404.505-.303 1.213.177 1.617h.025c.91.707 1.92 1.288 2.982 1.692.404.152.808.303 1.237.404 1.491.405 3.032.531 4.598.329a11.552 11.552 0 0 0 4.37-1.415c.38-.202.759-.454 1.112-.707a4.145 4.145 0 0 1-.555-.354 3.457 3.457 0 0 1-1.061-1.364l.025.05ZM2.324 11.722a9.724 9.724 0 0 1 .556-2.955c.025-.101.075-.177.1-.278a9.603 9.603 0 0 1 1.39-2.426 1.182 1.182 0 0 0-.202-1.616c-.505-.405-1.213-.304-1.617.176v.026c-.707.91-1.288 1.92-1.718 2.98v.051C.303 8.917.05 10.281 0 11.671a12.186 12.186 0 0 0 1.086 5.356c.303.682.682 1.313 1.111 1.92.102-.203.228-.38.354-.556.38-.48.834-.834 1.364-1.036a7.948 7.948 0 0 1-.707-1.288 10.106 10.106 0 0 1-.884-4.32v-.026Zm21.6-1.01c.076.732.1 1.49.025 2.223a12.1 12.1 0 0 1-.404 2.324 9.979 9.979 0 0 1-.38 1.137 12.439 12.439 0 0 1-1.692 2.981V19.427a1.182 1.182 0 0 1-1.617.177 1.162 1.162 0 0 1-.202-1.617 9.786 9.786 0 0 0 1.49-2.703c.077-.203.127-.405.203-.607.126-.455.227-.91.278-1.39a8.75 8.75 0 0 0 0-2.298 10.802 10.802 0 0 0-.43-1.996c0-.076-.05-.152-.075-.227l1.768-1.82c.253.556.48 1.137.657 1.719.202.682.328 1.364.404 2.071l-.025-.025Z"
          fill="#000"
        />
        <path
          d="M21.17.935c-.454 0-.833.152-1.111.304-.556.353-1.162 1.111-1.314 1.263-1.566 1.516-3.107 3.36-4.37 5.027-.834 1.112-1.794 2.552-2.88 4.32-.733-.859-1.34-1.566-1.769-2.071a1.976 1.976 0 0 0-1.49-.683c-.581 0-.91.152-1.364.455-1.01.733-1.01 2.223-.53 2.855.48.632 3.005 3.537 3.586 4.345.455.607 1.188 1.01 1.895 1.01.708 0 .43-.025.657-.1.91-.329 1.112-.784 1.49-1.49.38-.708.96-1.896 2.527-4.22.53-.783 1.54-2.324 3.436-4.497 1.92-2.172 2.45-2.45 2.955-2.98.48-.557.834-2.047-.252-2.982a2.182 2.182 0 0 0-1.465-.58v.024Z"
          fill="#FFB200"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawFormativeLogoIcon);
export default ForwardRef;
